import { Injectable } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { KnowledgeService } from 'src/app/services/knowledge/knowledge.service'
import {
  LOAD_KNOWLEDGE_SUMMARY_DETAILS,
  LOAD_KNOWLEDGE_SUMMARY_DETAILS_SUCCESS,
  load_knowledge_quick_option_details,
  load_knowledge_quick_option_details_success,
  search_knowledge_action,
  search_knowledge_success_action,
  view_knowledge_action,
  view_knowledge_success_action
} from '../action/knowledge.action'
import { catchError, map, mergeMap, of } from 'rxjs'
import { route_to_action, show_error_action } from '../action/common/common.action'

@Injectable()
export class KnowledgeEffects {
  constructor(private actions$: Actions, private knowledgeService: KnowledgeService) {}

  view_knowledge_action$ = createEffect(() =>
    this.actions$.pipe(
      ofType(view_knowledge_action),
      mergeMap(({ id }) =>
        this.knowledgeService.callViewApi(id).pipe(
          mergeMap(response => [view_knowledge_success_action({ knowledge: response })]),
          catchError((error: any) => of(show_error_action({ data: null, error: error })))
        )
      )
    )
  )

  search_knowledge_action$ = createEffect(() =>
    this.actions$.pipe(
      ofType(search_knowledge_action),
      mergeMap(data =>
        this.knowledgeService.invokeKnowledgeSummaryAPI(data.queryParams, data.searchRequestBody).pipe(
          mergeMap(response => [
            search_knowledge_success_action({ knowledge: response }),
            route_to_action({ routeTo: data.routeTo })
          ]),
          catchError((error: any) => of(show_error_action({ data: null, error: error })))
        )
      )
    )
  )

  load_knowledge_summary$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LOAD_KNOWLEDGE_SUMMARY_DETAILS),
      mergeMap(data =>
        this.knowledgeService.invokeKnowledgeSummaryAPI(data.queryParams, data.searchRequestBody).pipe(
          map(knowledgeResponse => LOAD_KNOWLEDGE_SUMMARY_DETAILS_SUCCESS({ knowledge: knowledgeResponse })),
          catchError((error: any) => of(show_error_action({ data: null, error: error })))
        )
      )
    )
  )

  load_quick_select_option$ = createEffect(() =>
    this.actions$.pipe(
      ofType(load_knowledge_quick_option_details),
      mergeMap(data =>
        this.knowledgeService.invokeKnowledgeSummaryAPI(data.queryParams, data.searchRequestBody).pipe(
          map(knowledgeResponse => load_knowledge_quick_option_details_success({ knowledge: knowledgeResponse })),
          catchError((error: any) => of(show_error_action({ data: null, error: error })))
        )
      )
    )
  )
}
